module.exports = __webpack_public_path__ + "media/fonts/stroyka/stroyka-98b20ca92c6342ab2372155c80cd5345.ttf";